import React , { useRef }from 'react'
import { useState } from 'react';
import { useMutation } from '@apollo/client';
import {
  SEND_PRIVATE_MSG,
  SEND_GROUP_MSG,
  SEND_GLOBAL_MSG,
} from '../../../graphql/mutations';
import { useStateContext } from '../../../context/state';

import EmojiPicker from '../../../components/EmojiPicker';
// import FileAttachment from '../../../components/FileAttachment';
// import ImageAttachment from '../../../components/ImageAttachment';

import { getErrorMsg } from '../../../utils/helperFuncs';

import { IconButton, TextField, InputAdornment } from '@material-ui/core';
import { useConversationPageStyles } from '../../../styles/muiStyles';
import SendIcon from '@material-ui/icons/Send';



const SendMessage = () => {
  const classes = useConversationPageStyles();
  const { selectedChat, notify } = useStateContext();
  const [messageBody, setMessageBody] = useState('');

  const [submitPrivateMsg, { loading: loadingPrivate }] = useMutation(
    SEND_PRIVATE_MSG,
    {
      onError: (err) => {
        notify(getErrorMsg(err), 'error');
      },
    }
  );
  const [submitGroupMsg, { loading: loadingGroup }] = useMutation(
    SEND_GROUP_MSG,
    {
      onError: (err) => {
        notify(getErrorMsg(err), 'error');
      },
    }
  );
  const [submitGlobalMsg, { loading: loadingGlobal }] = useMutation(
    SEND_GLOBAL_MSG,
    {
      onError: (err) => {
        notify(getErrorMsg(err), 'error');
      },
    }
  );

  const clearInput = () => {
    setMessageBody('');
  };

  const handleEmojiAdd = (emoji) => {
    setMessageBody((prevString) => prevString.concat(emoji));
  };

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (messageBody.trim() === '' || !selectedChat) return;

    if (selectedChat.chatType === 'private') {
      submitPrivateMsg({
        variables: { receiverId: selectedChat.chatData.id, body: messageBody },
        update: () => {
          clearInput();
        },
      });
    } else if (selectedChat.chatType === 'group') {
      submitGroupMsg({
        variables: {
          conversationId: selectedChat.chatData.id,
          body: messageBody,
        },
        update: () => {
          clearInput();
        },
      });
    } else {
      submitGlobalMsg({
        variables: { body: messageBody },
        update: () => {
          clearInput();
        },
      });
    }
  };
  const inputRef = useRef();
  const handleKeyDown = event => {
    if (event.keyCode === 13 && !event.shiftKey) {//<------use enter key to submit form
      inputRef.current.getElementsByTagName("textarea")[0].style.height = "auto";
      setMessageBody("") //<------resize text area
      handleSendMessage(event);
      event.preventDefault();
    }
    
  };

  return (
    <form className={classes.sendMsgForm} onSubmit={handleSendMessage}>

      <TextField
        ref={inputRef}
        onKeyDown={handleKeyDown} //<-----see here
        value={messageBody}
        fullWidth
        type="text"
        placeholder="Type a message..."
        variant="outlined"
        multiline
        onChange={(e) => setMessageBody(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <div>
                {messageBody.trim() !== '' && (
                  <IconButton
                    size="small"
                    color="primary"
                    type="submit"
                    disabled={loadingPrivate || loadingGroup || loadingGlobal}
                  >
                    <SendIcon fontSize="small" />
                  </IconButton>
                )}
              </div>
            </InputAdornment>
          ),
          startAdornment: (
            <InputAdornment position="start">
              <EmojiPicker fontSize="small" handleEmojiAdd={handleEmojiAdd} />

            </InputAdornment>
          ),
        }}
      />
    </form>
  );
};

export default SendMessage;
